import { Layout, Tag } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'

import { type SpotQuoteListItem } from '../domain/SpotQuoteListItem'
import { getBulkSpotQuoteItemTagsText } from '../presenter/spotQuotePresenter'

type BulkSpotQuoteTagsProps = {
  item: SpotQuoteListItem
}

export function BulkSpotQuoteTags({ item }: BulkSpotQuoteTagsProps) {
  const { lanes } = item
  const { expired, pending, submitted } = lanes

  const { expiredText, pendingText, submittedText } = getBulkSpotQuoteItemTagsText({
    expired,
    pending,
    submitted,
  })

  return (
    <Layout.Group>
      {pendingText && (
        <Tag variant="warning" leading={<Icon name="attention" size={12} />}>
          {pendingText}
        </Tag>
      )}
      {submittedText && (
        <Tag variant="success" leading={<Icon name="check" size={12} />}>
          {submittedText}
        </Tag>
      )}
      {expiredText && (
        <Tag variant="neutral" leading={<Icon name="hour-glass" size={12} />}>
          {expiredText}
        </Tag>
      )}
    </Layout.Group>
  )
}
